import { html, LitElement, unsafeCSS } from "lit-element"
import { classMap } from "lit-html/directives/class-map"
import { unsafeHTML } from "lit-html/directives/unsafe-html"
import commonStyle from "../common.css"
import style from "./tab.css"
import Ripple from "../ripple"

export default class extends LitElement {
	static styles = [unsafeCSS(style), unsafeCSS(commonStyle)]
	static get properties () {
		return {
			tabTitle: { type: String, attribute: "tab-title" },
			selected: { type: Boolean, attribute: "selected" }
		}
	}

	#selected = false
	constructor () {
		super()
		this.tabTitle = ""
	}

	render () {
		return html`
			<div class= ${this.tabClass} @click="${this.onClick}">${unsafeHTML(this.tabTitle)}</div>
		`
	}

	get selected () {
		return this.#selected
	}

	set selected (value) {
		if (this.#selected !== value) {
			this.#selected = value
			if (value) {
				this.updateComplete.then(() => {
					this.dispatchEvent(new CustomEvent("tab-selected", { composed: true, bubbles: true }))
				})
			}
			this.requestUpdate()
		}
	}

	onClick () {
		this.selected = true
	}

	get tabClass () {
		return classMap({
			tab: true,
			hl: true,
			"tab-text": this.selected
		})
	}

	firstUpdated () {
		new Ripple(this.renderRoot.querySelector(".tab")).init()
	}
}
